export default "__VITE_ASSET__Djpzxp7G__"